import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface IElementProps {
	color?: string;
	children?: ReactNode;
}

const style = css<IElementProps>`
	background-color: ${(props) => props.theme.colors[props.color ?? 'lightBlueDark']};
	color: white;
	font-size: 16px;
	padding: 12px 30px;
	display: inline-block;
	text-align: center;
	text-decoration: none;
	transition: 100ms background-color ease-out;
	border-radius: 6px;
	line-height: 12px;
`;

const AnchorElement = styled.a<IElementProps>`
	${style}
`;

// This element currently doesn't do anything, as the InboxTaskListItem itself is clickable
export default function InboxTaskItemButton({ color, children }: IElementProps) {
	return <AnchorElement color={color}>{children}</AnchorElement>;
}
